'use client'

import React from 'react'
import { AntdRegistry } from '@ant-design/nextjs-registry'
import { App } from 'antd'
import { ThemeProvider } from '@/shared/theme'
import StoreProvider from '@/shared/providers/state/StoreProvider'
import { AuthProvider as ReduxAuthProvider } from '@/shared/providers/auth/AuthProvider'
import { AuthProvider as DomainAuthProvider } from '@/domains/auth'
import { ReactQueryProvider } from '@/shared/providers/react-query/provider'
import { ErrorProvider } from '@/shared/components/error/ErrorContext'
import { ConditionalLayout } from '@/shared/layouts/shell/ConditionalLayout'
import { BrokerProvider } from '@/shared/providers/broker/BrokerContext'

interface ProvidersProps {
  children: React.ReactNode
}

/**
 * App providers tree.
 *
 * Theme path (sole): `ThemeProvider` → Ant Design `ConfigProvider`
 * (`createThemeConfig` in ThemeSystem) + CSS tokens/modules.
 * Tailwind was purged — do not reintroduce utility CSS frameworks here.
 */
export function Providers({ children }: ProvidersProps) {
  return (
    <AntdRegistry>
      <StoreProvider>
        <ErrorProvider>
          <ReactQueryProvider>
            {/* defaultMode=dark: flagship night-desk craft live (mechagora.flagship.theme) */}
            <ThemeProvider defaultMode="dark">
              <App>
                <ReduxAuthProvider>
                  <DomainAuthProvider>
                    <BrokerProvider>
                      <ConditionalLayout>
                        {children}
                      </ConditionalLayout>
                    </BrokerProvider>
                  </DomainAuthProvider>
                </ReduxAuthProvider>
              </App>
            </ThemeProvider>
          </ReactQueryProvider>
        </ErrorProvider>
      </StoreProvider>
    </AntdRegistry>
  )
}


export default Providers
